import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KioskExitComponent } from './kiosk-exit.component';
import { DialogLayoutModule } from '@fleet/ui';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AlertsFromIssuesModule } from '@fleet/issue';
import { FuseAlertModule } from '@fleet/fuse';

@NgModule({
  declarations: [KioskExitComponent],
  imports: [
    CommonModule,
    DialogLayoutModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    AlertsFromIssuesModule,
    FuseAlertModule,
  ],
  exports: [KioskExitComponent],
})
export class KioskExitModule {}
